/* eslint-disable */
import Api from '@/api/services/Api';

const route = '/user'

export default {
    get: params => {
        let customRoute = `${route}?expand=roles,status_description&search=${params.filter}`
        switch (params.usuarioEstado) {
            case "2": customRoute = `${route}?status=10&expand=roles,status_description&search=${params.filter}`
                break;
            case "3": customRoute = `${route}?status=9&expand=roles,status_description&search=${params.filter}`
                break;
            case "4": customRoute = `${route}?status=0&expand=roles,status_description&search=${params.filter}`
                break;
            default: break;
        }
        return Api().get(customRoute, { params, crossDomain: true })
    },
    getOne: payload => Api().get(`${route}/${payload.id}?expand=roles,status_description`),
    getAll: () => Api().get(`${route}`, { crossDomain: true }),
    getAllRecords: () => Api().get(`${route}?fields=id,username&expand=status_description`, { crossDomain: true }),
    getHistory: payload => Api().get(`${route}/${payload.id}?expand=roles,status_description,history`, { crossDomain: true }),
    post: payload => Api().post(`${route}?expand=roles,status_description`, payload),
    put: payload => Api().put(`${route}/${payload.id}?expand=roles,status_description`, payload),
    delete: payload => Api().delete(`${route}/${payload.id}?expand=roles,status_description`),
    roles: payload => Api().get(`${route}/${payload.id}?expand=roles`),
    toogleStatus: payload => Api().put(`${route}/toggle-status/${payload.id}?expand=roles,status_description`),
}
